module.exports = {
      id: "logout-mobile-usage",
      viewBox: "0 0 20.886 28.808",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#logout-mobile",
      toString: function () {
        return this.url;
      }
    }